import React from 'react';
import PropTypes from 'prop-types';
import BidsMakeAndModelProvider from '../../si-filter-table-frame/make-and-model/make-and-model-provider';
import EditBidLineModal, {
  EditBidLineModalDataType,
} from './edit-bid-line-item-modal';

const EditBidLineModalWrapper = ({
  onClose,
  initialData = {
    standardItemNumber: '',
    title: '',
    tags: { value: [] },
    afpMake: [],
  },
  isAdmin = false,
}) => {
  return (
    <BidsMakeAndModelProvider initialData={initialData}>
      <EditBidLineModal
        data={initialData}
        onClose={onClose}
        isAdmin={isAdmin}
      />
    </BidsMakeAndModelProvider>
  );
};

EditBidLineModalWrapper.propTypes = {
  onClose: PropTypes.func.isRequired,
  initialData: EditBidLineModalDataType,
  isAdmin: PropTypes.bool,
};

export default EditBidLineModalWrapper;
